import { useState, useContext, useEffect } from 'react';
import { Box, Typography, Avatar, Paper, CircularProgress } from '@mui/material';
import PrimaryButton from '../../components/PrimaryButton';
import BottomNavigator from '../../components/BottomNavigator';
import AutoNavigate from '../../components/AutoNavigate';
import { AuthContext } from '../../context/AuthContextProvider';
import { AppStateContext } from '../../context/AppStateContextProvider';

export default function ProfilePage() {
    const { setTokens, setLoginOtpRequest } = useContext(AuthContext);
    const { user, deviceFcmTokenSentToBackend } = useContext(AppStateContext);

    const firstLetter = user?.fullName?.charAt(0)?.toUpperCase() || '?';

    const [localStateUser, setLocalStateUser] = useState(null);

    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const logout = () => {
        setTokens({});
        setIsLoggingOut(false);
        setLoginOtpRequest(null);
    };

    const handleLogoutButtonClick = () => {
        setIsLoggingOut(true);

        if (!window.confirm('Are you sure you want to log out?')) {
            setIsLoggingOut(false);
            return;
        }

        logout();
    };

    useEffect(() => {
        if (user === null) {
            return;
        }

        setLocalStateUser(user);
    }, [user]);

    if (localStateUser === null) {
        return (
            <Box
                sx={{
                    width: '100vw',
                    height: '100dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }}
            >
                <AutoNavigate />
                <CircularProgress color="green" sx={{ mt: 4 }} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <AutoNavigate />
            <Box
                sx={{
                    width: '100%',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginTop: 4,
                }}
            >
                <Paper
                    elevation={1}
                    sx={{
                        borderRadius: 3,
                        p: 4,
                        textAlign: 'center',
                        maxWidth: 400,
                        mx: 'auto',
                        boxShadow: 10,
                    }}
                >
                    <Avatar
                        sx={{
                            width: 50,
                            height: 50,
                            fontSize: '1.5rem',
                            bgcolor: 'transparent',
                            color: '#333',
                            border: '4px solid #1b5e20', // green circular border
                            mx: 'auto',
                            mb: 2,
                        }}
                    >
                        {firstLetter}
                    </Avatar>

                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        {user.fullName}
                    </Typography>

                    <Typography variant="body1" sx={{ opacity: 0.7 }}>
                        {user.phoneNumber}
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 1, color: '#444' }}>
                        {user.locality?.name}
                    </Typography>
                </Paper>
            </Box>

            <Box
                sx={{
                    width: '100vw',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginBottom: 8,
                }}
            >
                <PrimaryButton text="Log Out" onClick={handleLogoutButtonClick} />
            </Box>

            <BottomNavigator />
        </Box>
    );
}
